import type { LogStorageService } from './log-storage.service';

export const LOG_BATCH_PREFIX = 'logs_v2_batch_';

/** Current-format batch keys, ordered oldest first without changing the input. */
export function selectLogBatchKeys(keys: readonly unknown[]): string[] {
  return keys
    .filter((key): key is string => typeof key === 'string' && key.startsWith(LOG_BATCH_PREFIX))
    .sort((a, b) => Number(a.slice(LOG_BATCH_PREFIX.length)) - Number(b.slice(LOG_BATCH_PREFIX.length)));
}

/** Read the newest entries in chronological order, leaving stored batches intact. */
export async function readRecentLogBatches<T>(
  storage: Pick<LogStorageService, 'keys' | 'get'>,
  limit: number,
): Promise<T[]> {
  const recentKeys = selectLogBatchKeys(await storage.keys()).reverse();
  let logs: T[] = [];
  for (const key of recentKeys) {
    if (logs.length >= limit) break;
    const batchLogs = await storage.get(key);
    if (Array.isArray(batchLogs)) {
      logs = [...logs, ...[...batchLogs].reverse()];
      if (logs.length > limit) logs = logs.slice(0, limit);
    }
  }
  return logs.reverse();
}
